import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Row, Col } from 'react-bootstrap';
import DonutChart from 'components/molecules/charts/DonutChart';
import TrackedComponentEnhancer from 'hoc/TrackedComponent';
import CallOutSimple from 'components/molecules/CallOutSimple';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { NORTHSTAR_METRICS_VIEW } from 'constants/capabilities';

const ContentWrapper = styled.div`
    border: solid 1px #AFAFAF;
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 15px;
    justify-content: center;
`;

const CalloutRow = styled(Row)`
    padding-left: 10px;
    padding-right: 20px;
    padding-top: 20px;
`;

const HomeHeader = styled.div`
    background-color: #F1F1F1;
    padding: 8px 0px 8px 20px;
    text-transform: uppercase;
    font-size: 16px;
    border-bottom: solid 1px #AFAFAF;
    align-self: stretch;
`;

const TrackedCallOutSimple = TrackedComponentEnhancer({
    trackedName: 'Northstar-Metric-Callout',
    targetComponent: CallOutSimple
});

const processForChart = (northStarData) => {
    if (!northStarData) {
        return [];
    }
    return Object.entries(northStarData).map(([key, value]) => ({
        name: key,
        y: value
    }));
};
const NorthStarMetricsView = (props) => {
    const { analytics: { northStarV2 = {} } } = props;
    return (
        <Grid fluid>
            <Row>
                <Col sm={12}>
                    <ContentWrapper>
                        <HomeHeader>Dashboard Analytics</HomeHeader>
                        <CalloutRow>
                            <Col xs={12} md={12} key={3}>
                                <TrackedCallOutSimple
                                    exportName="north-star-platforms"
                                    title="North Star - Avaliable Platforms"
                                    type="north_star_platforms"
                                    format="0,0"
                                    data={{
                                        value: northStarV2.platforms ? northStarV2.platforms.length : 0
                                    }}
                                />
                            </Col>
                        </CalloutRow>
                        <CalloutRow>
                            <Col md={12}>
                                <DonutChart
                                    title='Platform Use Distribution'
                                    exportName={'north-star-platform-distribution'}
                                    data={processForChart(northStarV2.platformDistribution)}
                                    y="platform use distribution"
                                    hideLegendLine
                                    totalFormat="0"
                                    total={northStarV2.platforms ? northStarV2.platforms.length : 0}
                                    totalTitle="Total Platforms"
                                    donutCaption="This donut chart shows the total distribution of platforms used across the dashboards."
                                />
                            </Col>
                        </CalloutRow>
                    </ContentWrapper>
                </Col>
            </Row>
        </Grid >
    );
};

NorthStarMetricsView.propTypes = {
    analytics: PropTypes.shape({
        northStar: PropTypes.arrayOf(
            PropTypes.shape({
                timestamp: PropTypes.string,
                value: PropTypes.number,
                meta: PropTypes.object
            })
        )
    })
};

export default ProtectedComponent({ requiredCapabilities: [NORTHSTAR_METRICS_VIEW] })(NorthStarMetricsView);



// WEBPACK FOOTER //
// ./src/components/organisms/analytics/NorthStarMetricsV2View.js